import React from 'react';
export const CFIconMenuArrow = {
    alias: 'menu-arrow',
    defaultTitle: 'Menu Arrow',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M3.948 5h16.104c.521 0 .948.427.948.948v.104a.951.951 0 0 1-.948.948H3.948A.951.951 0 0 1 3 6.052v-.104C3 5.427 3.427 5 3.948 5Zm16.104 6H5.913l1.293-1.293a.999.999 0 1 0-1.413-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a.999.999 0 1 0 1.413-1.414L5.913 13h14.139a.951.951 0 0 0 .948-.948v-.104a.951.951 0 0 0-.948-.948Zm0 6H3.948a.951.951 0 0 0-.948.948v.104c0 .521.427.948.948.948h16.104a.951.951 0 0 0 .948-.948v-.104a.951.951 0 0 0-.948-.948Z' }))),
};
